import React, { useRef } from 'react';
import heroImg from "../assets/hero-image.jpg"
const HomePage = () => {
  // Create a reference for the contact section
  const contactRef = useRef(null);

  // Function to scroll to the contact section
  const handleClick = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section
        className="hero bg-cover bg-center h-screen"
        id='home'
        style={{ backgroundImage: `url('${heroImg}')` }}
      >
        <div className="flex items-center justify-center h-full bg-black bg-opacity-50">
          <div className="text-center">
            <h1 className="text-white text-5xl font-bold">Welcome to Our Education Institute</h1>
            <p className="text-white text-lg mt-2">Empowering Minds Through Quality Education</p>
            <button
              className="mt-4 bg-blue-500 text-white px-6 py-2 rounded-md"
              onClick={handleClick}
            >
              Explore Our Courses
            </button>
          </div>
        </div>
      </section>

      {/* Other sections of your homepage go here */}

      {/* Contact Section */}
      <section ref={contactRef}>

      </section>
    </>
  );
};

export default HomePage;
